import { useEffect } from 'react'
import { useStore } from 'effector-react'
import {
  $budgetItems,
  $budgetPaymentForm,
  budgetItemsMounted,
} from './model'

export const useBudgetPaymentModal = (isOpenModal: boolean) => {
  const budgetItems = useStore($budgetItems)
  const budgetPaymentForm = useStore($budgetPaymentForm)

  useEffect(() => {
    if (isOpenModal) {
      budgetItemsMounted()
    }
  }, [isOpenModal])

  return { budgetItems, budgetPaymentForm }
}
